import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  PanelBottom,
  User,
  LogOut,
  Globe,
  RefreshCcw,
  Settings,
  Home,
  Menu,
  X,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const Header = (props) => {
  const { location, toggleLayout, largura, isSingleColumn } = props;
  const { logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { name, role } = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();
  const painelUsuario = () => navigate(`/user/edit`);
  const site = () => navigate("/");
  const painel = () => navigate("/painel");
  const gestores = () => navigate("/gestores");

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Header Principal */}
      <div className="bg-blue-600 shadow-lg">
        <div className="w-full mx-auto px-4 border border-black">
          <div className="flex justify-between items-center h-16 md:h-20">
            
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center">
              <div className="bg-white rounded-full p-2 shadow-md">
                <img
                  className="h-8 w-auto md:h-10"
                  src={"./logo_unisc.svg"}
                  alt="Logo UNISC"
                />
              </div>
            </div>

            {/* Nome do usuário - Desktop */}
            <div className="hidden md:flex items-center">
              <h4 className="font-league-gothic text-3xl text-white font-semibold">
                Olá, {name}
              </h4>
            </div>

            {/* Botões Desktop */}
            <div className="hidden md:flex items-center space-x-2">
              {/* Botão Lista */}
              <button
                className={`${
                  isSingleColumn 
                    ? 'bg-white text-black' 
                    : 'bg-white text-black'
                } flex items-center justify-center px-4 py-2 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium shadow-sm hover:shadow-md`}
                onClick={toggleLayout}
                title={isSingleColumn ? "Alternar para visualização em colunas" : "Alternar para visualização em lista"}
              >
                <RefreshCcw className="w-4 h-4 mr-2" />
                {isSingleColumn ? 'COLUNAS' : 'LISTA'}
              </button>

              {/* Botão Site */}
              <button
                className="bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center justify-center px-4 py-2 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium shadow-sm hover:shadow-md"
                onClick={site}
                title="Ir para o site"
              >
                <Home className="w-4 h-4 mr-2" />
                SITE
              </button>

              {/* Botão Gestão (Admin) */}
              {role === "administrador" && location !== "gestores" && (
                <button
                  className="bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center justify-center px-4 py-2 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium shadow-sm hover:shadow-md"
                  onClick={gestores}
                  title="Gerenciar gestores"
                >
                  <Settings className="w-4 h-4 mr-2" />
                  GESTÃO
                </button>
              )}

              {/* Botão Vendas (quando em gestores) */}
              {location === "gestores" && (
                <button
                  className="bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center justify-center px-4 py-2 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium shadow-sm hover:shadow-md"
                  onClick={painel}
                  title="Ir para vendas"
                >
                  <PanelBottom className="w-4 h-4 mr-2" />
                  VENDAS
                </button>
              )}

              {/* Botão Usuário */}
              <button
                className="bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center justify-center px-4 py-2 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium shadow-sm hover:shadow-md"
                onClick={painelUsuario}
                title="Configurações do usuário"
              >
                <User className="w-4 h-4 mr-2" />
                USUÁRIO
              </button>

              {/* Botão Sair */}
              <button
                className="bg-red-500 text-white hover:bg-red-600 flex items-center justify-center px-4 py-2 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium shadow-sm hover:shadow-md"
                onClick={logout}
                title="Sair do sistema"
              >
                <LogOut className="w-4 h-4 mr-2" />
                SAIR
              </button>
            </div>

            {/* Botão Menu Mobile */}
            <div className="md:hidden">
              <button
                className="bg-white text-gray-700 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                onClick={toggleMobileMenu}
                title="Abrir menu"
              >
                {isMobileMenuOpen ? (
                  <X className="w-6 h-6" />
                ) : (
                  <Menu className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Menu Mobile */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-blue-700 border-t border-blue-500">
            <div className="px-4 py-3 space-y-2">
              {/* Nome do usuário - Mobile */}
              <div className="text-white text-center pb-2 border-b border-blue-500">
                <h4 className="font-league-gothic text-xl">Olá, {name}</h4>
              </div>

              {/* Botões Mobile */}
              <div className="space-y-2">
                <button
                  className="w-full bg-white text-gray-700 hover:bg-gray-50 flex items-center justify-center px-4 py-3 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium"
                  onClick={() => { site(); closeMobileMenu(); }}
                >
                  <Home className="w-4 h-4 mr-2" />
                  SITE
                </button>

                {role === "administrador" && location !== "gestores" && (
                  <button
                    className="w-full bg-white text-gray-700 hover:bg-gray-50 flex items-center justify-center px-4 py-3 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium"
                    onClick={() => { gestores(); closeMobileMenu(); }}
                  >
                    <Settings className="w-4 h-4 mr-2" />
                    GESTÃO
                  </button>
                )}

                {location === "gestores" && (
                  <button
                    className="w-full bg-white text-gray-700 hover:bg-gray-50 flex items-center justify-center px-4 py-3 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium"
                    onClick={() => { painel(); closeMobileMenu(); }}
                  >
                    <PanelBottom className="w-4 h-4 mr-2" />
                    VENDAS
                  </button>
                )}

                <button
                  className="w-full bg-white text-gray-700 hover:bg-gray-50 flex items-center justify-center px-4 py-3 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium"
                  onClick={() => { painelUsuario(); closeMobileMenu(); }}
                >
                  <User className="w-4 h-4 mr-2" />
                  USUÁRIO
                </button>

                <button
                  className="w-full bg-red-500 text-white hover:bg-red-600 flex items-center justify-center px-4 py-3 rounded-lg transition-all duration-200 font-league-gothic text-base font-medium"
                  onClick={() => { logout(); closeMobileMenu(); }}
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  SAIR
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
